module.exports = __webpack_public_path__ + "img/ch21_03_空城橱窗.3acbd428.jpg";